import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'headerButtons';
  const widgetOpts = headerButtonsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 2,
    maxItemsVisible: 2,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        createCustomTicketBtn(data.items);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData?.[x] || {};
      if (!URL) return $(this).remove();

      const btnClass = x === 0 ? 'ticket-button' : 'donate-button';
      const external = isLocalUrl(URL) ? '' : ' target="_blank" rel="noopener noreferrer"';

      $(this).replaceWith(`
      <a class="header-btn ${btnClass}" href="${URL}"${external} aria-label="${Title || ''}" tabindex="0">
        <span class="tkt-text">${Title || ''}</span>
      </a>
    `);
    });
  }
}
